module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/2@2x_63b233a6b999dff7240a5aa9d76cfcba.png";